export default __webpack_public_path__ + "static/media/407.2475dbad.png";